<template>
  <div class="col-12 col-md-12 col-lg-8">
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-10 col-xl-10">     
        <form @submit.prevent="submit">
          <div class="form-row">
            <div class="form-group col-12 col-md-4">
              <label for="zipcode">CEP *</label>
              <input name="zipcode" tabindex="1" type="text" class="form-control form-control-lg" pattern="\d{5}-?\d{3}" v-model="zipcode" v-mask="'zipcode'" placeholder="CEP" @change="handleZipcodeChange" v-focus required>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-6">
              <label for="street">Endereço *</label>
              <input type="text" tabindex="2" class="form-control form-control-lg" v-model="street" placeholder="Logradouro" :disabled="isSearchingAddress" required>
            </div>
            <div class="form-group col-12 col-md-2">
              <label for="inputPassword4">Número *</label>
              <input type="text" tabindex="3" class="form-control form-control-lg" v-model.number="number" pattern="\d+" title="Números apenas" v-mask="'integer'" placeholder="Nº" :disabled="isSearchingAddress" required>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="complement">Complemento</label>
              <input type="text" tabindex="4" class="form-control form-control-lg" v-model="complement" placeholder="Complemento" :disabled="isSearchingAddress">
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-12 col-md-4">
              <label for="neighborhood">Bairro *</label>
              <input type="text" tabindex="5" class="form-control form-control-lg" v-model="neighborhood" placeholder="Bairro" :disabled="isSearchingAddress" required/>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="state">Estado *</label>
              <at-select ref="stateSelect" tabindex="6" class="focus-select" v-model="state" filterable size="large" :disabled="estaEstadoDesabilitado" :placeholder="statePlaceholder" @on-change="onUfChange" required>
                <at-option v-for="(state, i) in states" :key="`stateOptions${i}`" :value="state.uf">{{typeof state.nome=='undefined' ? state.uf : state.nome}}</at-option>
              </at-select>
            </div>
            <div class="form-group col-12 col-md-4">
              <label for="city">Cidade *</label>
              <at-select ref="citySelect" tabindex="7" class="focus-select" v-model="city" filterable size="large" :disabled="estaCidadeDesabilitado" :placeholder="cityPlaceholder" required>
                <at-option v-for="(city, i) in cities" :key="`cityOptions${i}`"  :value="city.nome">{{city.nome}}</at-option>
              </at-select>
            </div>
          </div>
          <div class="text-center fixedOptions">
            <button class="btn btn-lg btn-primary">Próximo <img src="/static/assets/images/angle-right.svg"></button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Masker from '@/utils/masker'
  import HubConsultaClient from '@/utils/hub-consulta-client'
  import StringHelper from '@/utils/string-helper'

  export default {
    data() {
      return {
        zipcode: this.address.zipcode,
        neighborhood: this.address.neighborhood,
        complement: this.address.complement,
        street: this.address.street,
        number: this.address.number,
        state: this.address.state,
        city: this.address.city,
        isSearchingAddress: false,
        isSearchingStates:false,
        statePlaceholder:'Carregando',
        states: [],
        cities: []
      }
    },
    props: {
      address: {required: true, type: Object}
    },
    computed: {
      estaCidadeDesabilitado: function() { return this.isSearchingAddress || this.cities.length == 0 },
      estaEstadoDesabilitado: function() { return this.isSearchingAddress || this.isSearchingStates },
      cityPlaceholder: function() { 
        if((this.isSearchingAddress || 
          this.cities.length == 0) && 
          typeof this.state != 'undefined'){ return 'Carregando' } 
        else { return 'Cidade' }
      }
    },
    methods: {
      handleZipcodeChange(e) {
        if(Masker.unmaskZipcode(e.target.value).length < 8) return
        this.isSearchingAddress = true
        HubConsultaClient.pegarCeps(e.target.value)
          .then(endereco => {
            this.street = endereco.logradouro
            this.neighborhood = endereco.bairro
            this.state = endereco.uf
            this.city = endereco.localidade

            this.isSearchingAddress = false

            if(this.states=='' && typeof endereco.uf != 'undefined'){
              this.states = [{uf:endereco.uf}]
              this.isSearchingStates = false
              this.statePlaceholder = 'Estado'
              setTimeout(() => {this.state = endereco.uf}, 100)
            }
          })
          .catch(() => {
            this.isSearchingAddress = false
          })
      },
      onUfChange() {
        if(!this.state) {
          this.city = ''
          return
        }
        HubConsultaClient.pegarCidades(this.state)
          .then(cities => {
            this.cities = cities
            if(this.city) {
              this.setCity()
            }
          })
      },
      setCity() {
        const city = this.cities.find(city => {
          return StringHelper.removeAccents(city.nome.toUpperCase()) == StringHelper.removeAccents(this.city.toUpperCase())
        })
        if(!city) {
          this.city = ''
        } else {
          // When the city state is seted before cities is populated the component doesn't show
          // the selected city.
          this.city = ''
          setTimeout(() => this.city = city.nome, 100)
        }
      },
      submit() {
        if(this.city != undefined && this.state != undefined) {
          const newData = {
            zipcode: Masker.unmaskZipcode(this.zipcode),
            street: this.street,
            number: this.number,
            complement: this.complement,
            neighborhood: this.neighborhood,
            state: this.state,
            city: this.city
          }
          this.$emit('submit', newData)
        }
      }
    },
    created() {
      this.isSearchingStates = true
      HubConsultaClient.pegarEstados()
        .then(states => {
          this.states = states
          
          this.statePlaceholder = 'Estado'
          this.isSearchingStates = false
          // When the city state is seted before cities is populated the component doesn't show
          // the selected city.
          const state = this.state
          const city = this.city
          this.state = ''
          setTimeout(() => {
            this.state = state
            this.city = city
          }, 100)
        })
    },
    mounted() {
      this.$refs.stateSelect.$el.children[0].children[2].required = true;
      this.$refs.citySelect.$el.children[0].children[2].required = true;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AddressForm.vue